module.exports = __webpack_public_path__ + "static/member-1-15a63375cbc272d327cc6bd612dd8086.jpg";